var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Edición de contenedor " + _vm._s(_vm.number))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("p", [
            _c("label", { attrs: { for: "aprobado_b" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.aprobado_b,
                    expression: "form.aprobado_b"
                  }
                ],
                attrs: {
                  disabled: !_vm.permiteAprobarCaja,
                  type: "checkbox",
                  name: "aprobado_b",
                  id: "aprobado_b"
                },
                domProps: {
                  checked: Array.isArray(_vm.form.aprobado_b)
                    ? _vm._i(_vm.form.aprobado_b, null) > -1
                    : _vm.form.aprobado_b
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.form.aprobado_b,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.form, "aprobado_b", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "aprobado_b",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "aprobado_b", $$c)
                      }
                    },
                    _vm.changeFechaAprobacion
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Aprobación (Caja)")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field datepicker-field--stretch" },
            [
              _c("date-picker", {
                attrs: {
                  disabled: !_vm.permiteAprobarCaja || !_vm.form.aprobado_b,
                  type: "date",
                  format: "dd-MM-yyyy",
                  id: "date_a_b",
                  lang: "es"
                },
                model: {
                  value: _vm.form.date_a_b,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "date_a_b", $$v)
                  },
                  expression: "form.date_a_b"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de aprobación (Caja)")]),
              _vm._v(" "),
              _vm.errores.date_a_b
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.date_a_b[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.esMaquina,
              expression: "esMaquina"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c("p", [
              _c("label", { attrs: { for: "aprobado_m" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.aprobado_m,
                      expression: "form.aprobado_m"
                    }
                  ],
                  attrs: {
                    disabled: !_vm.permiteAprobarMaquina,
                    type: "checkbox",
                    name: "aprobado_m",
                    id: "aprobado_m"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.aprobado_m)
                      ? _vm._i(_vm.form.aprobado_m, null) > -1
                      : _vm.form.aprobado_m
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.aprobado_m,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "aprobado_m",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "aprobado_m",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "aprobado_m", $$c)
                        }
                      },
                      _vm.changeAprobacionMaquina
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Aprobación (Máquina)")])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.esMaquina,
              expression: "esMaquina"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "datepicker-field datepicker-field--stretch" },
              [
                _c("date-picker", {
                  attrs: {
                    disabled:
                      !_vm.permiteAprobarMaquina || !_vm.form.aprobado_m,
                    type: "date",
                    format: "dd-MM-yyyy",
                    id: "date_a_m",
                    lang: "es"
                  },
                  model: {
                    value: _vm.form.date_a_m,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "date_a_m", $$v)
                    },
                    expression: "form.date_a_m"
                  }
                }),
                _vm._v(" "),
                _c("label", [_vm._v("Fecha de aprobación (Máquina)")]),
                _vm._v(" "),
                _vm.errores.date_a_m
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.date_a_m[0]))])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c("p", [
            _c("label", { attrs: { for: "invoiced_box" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.invoiced_box,
                    expression: "form.invoiced_box"
                  }
                ],
                attrs: {
                  disabled: !_vm.permiteFacturarCaja,
                  type: "checkbox",
                  name: "invoiced_box",
                  id: "invoiced_box"
                },
                domProps: {
                  checked: Array.isArray(_vm.form.invoiced_box)
                    ? _vm._i(_vm.form.invoiced_box, null) > -1
                    : _vm.form.invoiced_box
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.form.invoiced_box,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "invoiced_box",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "invoiced_box",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "invoiced_box", $$c)
                      }
                    },
                    _vm.changeFacturacionCaja
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Facturación (Caja)")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-field" }, [
          _c(
            "div",
            { staticClass: "datepicker-field datepicker-field--stretch" },
            [
              _c("date-picker", {
                attrs: {
                  disabled: !_vm.permiteFacturarCaja || !_vm.form.invoiced_box,
                  type: "date",
                  format: "dd-MM-yyyy",
                  id: "date_i_b",
                  lang: "es"
                },
                model: {
                  value: _vm.form.date_i_b,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "date_i_b", $$v)
                  },
                  expression: "form.date_i_b"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Fecha de facturación (Caja)")]),
              _vm._v(" "),
              _vm.errores.date_i_b
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [_c("strong", [_vm._v(_vm._s(_vm.errores.date_i_b[0]))])]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.esMaquina,
              expression: "esMaquina"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c("p", [
              _c("label", { attrs: { for: "invoiced_machine" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.invoiced_machine,
                      expression: "form.invoiced_machine"
                    }
                  ],
                  attrs: {
                    disabled: !_vm.permiteFacturarMaquina,
                    type: "checkbox",
                    name: "invoiced_machine",
                    id: "invoiced_machine"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.invoiced_machine)
                      ? _vm._i(_vm.form.invoiced_machine, null) > -1
                      : _vm.form.invoiced_machine
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.form.invoiced_machine,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "invoiced_machine",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "invoiced_machine",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "invoiced_machine", $$c)
                        }
                      },
                      _vm.changeFechaFacturacionM
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Facturación (Máquina)")])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.esMaquina,
              expression: "esMaquina"
            }
          ],
          staticClass: "col-xs-12 col-md-6"
        },
        [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "datepicker-field datepicker-field--stretch" },
              [
                _c("date-picker", {
                  attrs: {
                    disabled:
                      !_vm.permiteFacturarMaquina || !_vm.form.invoiced_machine,
                    type: "date",
                    format: "dd-MM-yyyy",
                    id: "date_i_m",
                    lang: "es"
                  },
                  model: {
                    value: _vm.form.date_i_m,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "date_i_m", $$v)
                    },
                    expression: "form.date_i_m"
                  }
                }),
                _vm._v(" "),
                _c("label", [_vm._v("Fecha de facturación (Máquina)")]),
                _vm._v(" "),
                _vm.errores.date_i_m
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.date_i_m[0]))])]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-success",
          attrs: {
            disabled:
              !_vm.permiteAprobarCaja &&
              !_vm.permiteAprobarMaquina &&
              !_vm.permiteFacturarCaja &&
              !_vm.permiteFacturarMaquina,
            type: "button"
          },
          on: { click: _vm.aceptar }
        },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _c("span", [_vm._v("Aceptar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cancelar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-ban" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38298198", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38298198","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/EdicionHistorico.vue
// module id = 349
// module chunks = 0